export enum ApiErrors {
  AlreadyExists,
  NotFound,
  BadRequest,
  InternalServerError,
}
